<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M49.6681 31.2277H50.3025C50.9071 31.2277 51.3959 30.7388 51.3959 30.1342C51.3959 29.5297 51.8848 29.0408 52.4894 29.0408H57.3407C57.9452 29.0408 58.4341 29.5297 58.4341 30.1342C58.4341 30.7388 58.9229 31.2277 59.5275 31.2277H60.1544C60.7291 31.2277 61.2068 30.7836 61.2441 30.2126C61.3262 29.0707 61.4008 27.3765 59.8857 27.3765H49.8323C48.6531 27.3765 48.6046 28.9774 48.5785 30.1156C48.5635 30.7276 49.0599 31.2277 49.6719 31.2277H49.6681Z"
            class="primary-fill" />
        <path
            d="M79.7867 43.748C82.44 42.2739 84.4178 40.0013 85.7239 36.9263C87.0301 33.8513 87.351 30.6644 86.683 27.3692L85.1157 19.6407L74.5585 17.9502L65.4902 23.6188L67.0576 31.3473C67.7256 34.6462 69.2593 37.4562 71.6626 39.7774C74.0621 42.0985 76.7714 43.4233 79.7904 43.748H79.7867Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.6523 28.6006L77.3584 33.4855L90.5838 18.3494"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-linejoin="round" />
        <path
            d="M66.582 11.6622V12.8564"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.582 15.0693V16.2672"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M64.2793 13.9646H65.4735"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.6895 13.9646H68.8836"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.1406 31.0413V32.2354"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.1406 34.452V35.6462"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.8379 33.3438H91.0321"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M93.2441 33.3438H94.4383"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M51.8182 111.024H68.503C73.1901 111.163 76.6569 107.692 76.6569 103.415V57.4137C72.4587 75.2852 67.4805 98.2841 64.2451 98.3961C60.8417 98.5118 65.9841 57.2644 61.8007 56.5367C60.7521 56.3539 59.1885 58.6377 56.9793 64.4145C48.9224 85.4991 45.9929 99.635 44.7204 99.5417C43.7912 99.4746 43.1642 100.199 44.0151 69.0382"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-linejoin="round" />
        <path
            d="M48.9746 111.181H42.1977C37.4247 111.181 33.5586 107.311 33.5586 102.542V79.3341"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.8008 49.1514H67.7569C72.5299 49.1514 76.396 53.0212 76.396 57.7904"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.0176 49.1403V28.9476"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.7891 49.1403V28.9476"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M63.8046 116.338C65.1669 116.338 66.2713 115.234 66.2713 113.872C66.2713 112.509 65.1669 111.405 63.8046 111.405C62.4423 111.405 61.3379 112.509 61.3379 113.872C61.3379 115.234 62.4423 116.338 63.8046 116.338Z"
            class="primary-fill" />
        <path
            d="M42.1977 111.181C37.4247 111.181 33.5586 107.311 33.5586 102.542V58.4549C33.5586 53.5514 37.5329 49.577 42.4365 49.577H55.2216"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.8008 49.1514H67.7569C72.5299 49.1514 76.396 53.0212 76.396 57.7904"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.0059 104.919H37.7451C41.0291 104.919 43.6898 107.58 43.6898 110.864"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.809 104.919H72.0697C68.7858 104.919 66.125 107.58 66.125 110.864"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.623 116.338C46.9853 116.338 48.0897 115.234 48.0897 113.872C48.0897 112.509 46.9853 111.405 45.623 111.405C44.2606 111.405 43.1562 112.509 43.1562 113.872C43.1562 115.234 44.2606 116.338 45.623 116.338Z"
            class="primary-fill" />
    </svg>
</template>
